import { onMounted, onUnmounted, inject } from 'vue';

/**
 * Composable for handling step validation
 * @param {Object} options Configuration options
 * @param {boolean} options.initialValidState Initial validation state (default: true)
 * @param {Function} options.validateFn Custom validation function (optional)
 * @returns {Object} Validation methods and state
 */
export function useStepValidation(options = {}) {
    const {
        initialValidState = true,
        validateFn = null
    } = options;

    const setPageValidation = inject('setPageValidation');

    // Default validation handler that always returns true
    const defaultValidateHandler = async (event) => {
        event.detail.callback(true);
    };

    // Use custom validation function if provided, otherwise use default
    const validateHandler = async (event) => {
        if (validateFn) {
            const isValid = await validateFn();
            event.detail.callback(isValid);
        } else {
            defaultValidateHandler(event);
        }
    };

    // Setup validation when component mounts
    onMounted(() => {
        setPageValidation(initialValidState);
        window.addEventListener('validate-step', validateHandler);
    });

    // Cleanup when component unmounts
    onUnmounted(() => {
        window.removeEventListener('validate-step', validateHandler);
    });

    return {
        validateHandler
    };
} 